var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showMenuAndFooter)?[_c('MenuBar')]:_vm._e(),(_vm.showMenuLateral)?[_c('MenuLateral')]:_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.showMenuAndFooter)?[_c('FooterBar')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }